function t(r) {
  return r.split("");
}
export {
  t as default
};
